var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-easy-dialog",
    {
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("div", { staticClass: "recommend" }, [
        _c(
          "button",
          {
            staticClass: "recommend__close",
            on: {
              click: function ($event) {
                return _vm.$emit("closePopup")
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/icons/cross.svg"), alt: "x" },
            }),
          ]
        ),
        _c("span", [_vm._v("Recommend skin concierge")]),
        _c(
          "a",
          { staticClass: "recommend__link picto_line", attrs: { href: "#" } },
          [
            _c(
              "span",
              { staticClass: "picto_line__text recommend__link__text" },
              [_vm._v("e-mail ")]
            ),
            _c("img", {
              staticClass: "picto_line__picto",
              attrs: {
                "svg-inline": "",
                src: require("@/assets/icons/email.svg"),
              },
            }),
          ]
        ),
        _c(
          "a",
          { staticClass: "recommend__link picto_line", attrs: { href: "#" } },
          [
            _c(
              "span",
              { staticClass: "picto_line__text recommend__link__text" },
              [_vm._v("instagram ")]
            ),
            _c("img", {
              staticClass: "picto_line__picto",
              attrs: {
                "svg-inline": "",
                src: require("@/assets/icons/instagram.svg"),
              },
            }),
          ]
        ),
        _c(
          "a",
          { staticClass: "recommend__link picto_line", attrs: { href: "#" } },
          [
            _c(
              "span",
              { staticClass: "picto_line__text recommend__link__text" },
              [_vm._v("whatsapp ")]
            ),
            _c("img", {
              staticClass: "picto_line__picto",
              attrs: {
                "svg-inline": "",
                src: require("@/assets/icons/whatsapp.svg"),
              },
            }),
          ]
        ),
        _c(
          "a",
          { staticClass: "recommend__link picto_line", attrs: { href: "#" } },
          [
            _c(
              "span",
              { staticClass: "picto_line__text recommend__link__text" },
              [_vm._v("copy link ")]
            ),
            _c("img", {
              staticClass: "picto_line__picto",
              attrs: {
                "svg-inline": "",
                src: require("@/assets/icons/link.svg"),
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }